module.exports = __webpack_public_path__ + "static/media/161-ivory-coast.1f7c9e84.svg";